// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"AdminManager_wrap_div__2zG9_","content_div":"AdminManager_content_div__1ULAh"};